import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import img from '../../assets/images/breadcrumb/ChatBc.png'
import {Image} from 'primereact/image';

export default function Breadcrumbs() {
    const {pathname} = useLocation()
    const {t} = useTranslation()

    return <div className={'w-full h-8rem bg-blue-100 border-round shadow-1 overflow-hidden'}>
        <div className={'flex align-items-center h-full px-6 justify-content-between'}>
            <span className={'sm:text-xl lg:text-2xl font-medium font-bold'}>
                {t(`breadcrumbs.${pathname.split('/').at(-1)}`)}
            </span>
            <Image src={img} style={{marginTop: "4.8rem"}}/>
        </div>
    </div>
}